import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import api from '../api';
import DataTable from '../components/DataTable';

const ONCELIK_RENK = { DUSUK:'#90a4ae', NORMAL:'#1565c0', YUKSEK:'#e65100', ACIL:'#b71c1c' };
const DURUM_RENK = { BEKLEMEDE:'#e65100', DEVAM_EDIYOR:'#1565c0', TAMAMLANDI:'#1b5e20', IPTAL:'#888' };

export default function Gorevler() {
  const { kullanici } = useContext(AuthContext);
  const navigate = useNavigate();
  const [veriler, setVeriler] = useState([]);
  const [toplam, setToplam] = useState(0);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [filtre, setFiltre] = useState({ durum:'' });
  const [modalAcik, setModalAcik] = useState(false);
  const [secili, setSecili] = useState(null);
  const [personeller, setPersoneller] = useState([]);
  const [form, setForm] = useState({ ruhsat_id:'', atanan:'', baslik:'', aciklama:'', oncelik:'NORMAL', son_tarih:'' });
  const [ruhsatArama, setRuhsatArama] = useState('');
  const [ruhsatSonuc, setRuhsatSonuc] = useState([]);

  useEffect(() => { yukle(); }, [filtre]); // eslint-disable-line
  useEffect(() => { api.get('/tanimlar/kullanicilar').then(r=>setPersoneller(r.data||[])).catch(()=>{}); }, []);

  const yukle = async () => {
    setYukleniyor(true);
    try {
      const p = new URLSearchParams({ ...filtre, limit:100 });
      const r = await api.get(`/gorev?${p}`);
      setVeriler(r.data.veriler||[]); setToplam(r.data.toplam||0);
    } finally { setYukleniyor(false); }
  };

  const ruhsatAra = async () => {
    if (!ruhsatArama) return;
    const r = await api.get(`/ruhsat?q=${ruhsatArama}&limit=10`);
    setRuhsatSonuc(r.data.veriler||[]);
  };

  const kaydet = async (e) => {
    e.preventDefault();
    try {
      await api.post('/gorev', form);
      yukle(); setModalAcik(false);
      setForm({ ruhsat_id:'', atanan:'', baslik:'', aciklama:'', oncelik:'NORMAL', son_tarih:'' });
      setRuhsatArama(''); setRuhsatSonuc([]);
    } catch(err) { alert(err.response?.data?.hata||'Hata'); }
  };

  const durumGuncelle = async (id, durum) => {
    try { await api.put(`/gorev/${id}`, { durum }); yukle(); } catch(err) { alert(err.response?.data?.hata||'Hata'); }
  };

  const fmt = d => d ? new Date(d).toLocaleDateString('tr-TR') : '—';
  const gecikti = r => r.son_tarih && new Date(r.son_tarih) < new Date() && r.durum !== 'TAMAMLANDI';

  const columns = [
    { key:'oncelik', label:'Öncelik', width:'80px', render:v=><span style={{fontSize:'11px',fontWeight:'700',color:ONCELIK_RENK[v]||'#555'}}>{v}</span> },
    { key:'baslik', label:'Görev Başlığı', render:(v,r)=>
      <div>
        <div style={{fontSize:'13px',fontWeight:'600',color:gecikti(r)?'#c62828':'#333'}}>{v}{gecikti(r)&&<span style={{marginLeft:'6px',fontSize:'10px',color:'#c62828'}}>⚠ GECİKTİ</span>}</div>
        {r.ruhsat_unvan&&<div style={{fontSize:'11px',color:'#3949ab'}}>{r.rn} — {r.ruhsat_unvan}</div>}
      </div>
    },
    { key:'atanan_adi', label:'Atanan', width:'130px', render:v=><span style={{fontSize:'12px'}}>{v||'—'}</span> },
    { key:'atayan_adi', label:'Atayan', width:'130px', render:v=><span style={{fontSize:'11px',color:'#888'}}>{v||'—'}</span> },
    { key:'son_tarih', label:'Son Tarih', width:'100px', render:(v,r)=><span style={{fontSize:'12px',color:gecikti(r)?'#c62828':'#333',fontWeight:gecikti(r)?'700':'400'}}>{fmt(v)}</span>, exportValue:r=>fmt(r.son_tarih) },
    { key:'durum', label:'Durum', width:'110px', render:v=><span style={{fontSize:'11px',fontWeight:'700',color:DURUM_RENK[v]||'#555'}}>{v?.replace(/_/g,' ')}</span> },
    { key:'_islem', label:'İşlem', width:'140px', sortable:false, filterable:false,
      render:(_,r)=>(
        <div style={{display:'flex',gap:'4px',flexWrap:'wrap'}}>
          {r.durum==='BEKLEMEDE'&&<button className="btn btn-outline btn-xs" onClick={e=>{e.stopPropagation();durumGuncelle(r.id,'DEVAM_EDIYOR');}}>▶ Başla</button>}
          {r.durum!=='TAMAMLANDI'&&r.durum!=='IPTAL'&&<button className="btn btn-success btn-xs" onClick={e=>{e.stopPropagation();durumGuncelle(r.id,'TAMAMLANDI');}}>✓ Tamam</button>}
          {r.ruhsat_id&&<button className="btn btn-secondary btn-xs" onClick={e=>{e.stopPropagation();navigate(`/ruhsat/${r.ruhsat_id}`);}}>→</button>}
        </div>
      )
    },
  ];

  const bekleyen = veriler.filter(v=>['BEKLEMEDE','DEVAM_EDIYOR'].includes(v.durum)).length;
  const acil = veriler.filter(v=>v.oncelik==='ACIL'&&v.durum!=='TAMAMLANDI').length;

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'20px',flexWrap:'wrap',gap:'8px'}}>
        <div>
          <h2 style={{color:'#1a237e',fontSize:'20px'}}>✅ Görev Yönetimi</h2>
          <div style={{fontSize:'12px',color:'#888',marginTop:'2px'}}>{bekleyen} bekleyen görev {acil>0&&<span style={{color:'#c62828',fontWeight:'700'}}>— {acil} ACİL</span>}</div>
        </div>
        <button className="btn btn-primary" onClick={()=>setModalAcik(true)}>➕ Görev Ata</button>
      </div>

      <div className="card">
        <div style={{display:'flex',gap:'8px',marginBottom:'12px',flexWrap:'wrap'}}>
          {[['','Tümü'],['BEKLEMEDE','Bekleyen'],['DEVAM_EDIYOR','Devam Ediyor'],['TAMAMLANDI','Tamamlanan'],['IPTAL','İptal']].map(([k,v])=>(
            <button key={k} className={`btn btn-sm ${filtre.durum===k?'btn-primary':'btn-outline'}`} onClick={()=>setFiltre({...filtre,durum:k})}>{v}</button>
          ))}
        </div>
        <div style={{marginBottom:'8px',fontSize:'12px',color:'#666'}}>Toplam: <strong>{toplam}</strong> görev</div>
        <DataTable columns={columns} data={veriler} filename="gorevler" pdfTitle="Görev Listesi" loading={yukleniyor} />
      </div>

      {modalAcik && (
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setModalAcik(false)}>
          <div className="modal" style={{maxWidth:'540px'}}>
            <div className="modal-header"><span className="modal-title">Yeni Görev Ata</span><button className="modal-close" onClick={()=>setModalAcik(false)}>×</button></div>
            <form onSubmit={kaydet}>
              <div className="form-grid">
                <div className="form-group" style={{gridColumn:'1/-1'}}>
                  <label>İlgili İşyeri (opsiyonel)</label>
                  <div style={{display:'flex',gap:'8px'}}>
                    <input value={ruhsatArama} onChange={e=>setRuhsatArama(e.target.value)} placeholder="Ruhsat no veya işyeri adı..." className="search-input" onKeyDown={e=>e.key==='Enter'&&(e.preventDefault(),ruhsatAra())} />
                    <button type="button" className="btn btn-outline" onClick={ruhsatAra}>Ara</button>
                  </div>
                  {ruhsatSonuc.length>0&&(
                    <div style={{border:'1px solid #ddd',borderRadius:'4px',marginTop:'4px',maxHeight:'130px',overflowY:'auto',background:'#fff'}}>
                      {ruhsatSonuc.map(r=>(
                        <div key={r.id} onClick={()=>{setForm(f=>({...f,ruhsat_id:r.id}));setRuhsatArama(`${r.rn} - ${r.unvan}`);setRuhsatSonuc([]);}}
                          style={{padding:'8px 12px',cursor:'pointer',borderBottom:'1px solid #f0f0f0',fontSize:'13px'}}
                          onMouseOver={e=>e.currentTarget.style.background='#f5f5ff'} onMouseOut={e=>e.currentTarget.style.background='#fff'}>
                          <strong>{r.rn}</strong> — {r.unvan}
                        </div>
                      ))}
                    </div>
                  )}
                  {form.ruhsat_id&&<div style={{fontSize:'12px',color:'#1b5e20',marginTop:'4px'}}>✅ Seçildi <button type="button" style={{color:'#c62828',background:'none',border:'none',cursor:'pointer'}} onClick={()=>{setForm(f=>({...f,ruhsat_id:''}));setRuhsatArama('');}}>✕</button></div>}
                </div>
                <div className="form-group" style={{gridColumn:'1/-1'}}><label>Görev Başlığı *</label><input value={form.baslik} onChange={e=>setForm({...form,baslik:e.target.value})} required /></div>
                <div className="form-group">
                  <label>Atanan Personel *</label>
                  <select value={form.atanan} onChange={e=>setForm({...form,atanan:e.target.value})} required>
                    <option value="">Seçin...</option>
                    {personeller.map(p=><option key={p.id} value={p.id}>{p.ad_soyad} ({p.rol})</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Öncelik</label>
                  <select value={form.oncelik} onChange={e=>setForm({...form,oncelik:e.target.value})}>
                    {Object.keys(ONCELIK_RENK).map(k=><option key={k} value={k}>{k}</option>)}
                  </select>
                </div>
                <div className="form-group"><label>Son Tarih</label><input type="date" value={form.son_tarih} onChange={e=>setForm({...form,son_tarih:e.target.value})} /></div>
                <div className="form-group" style={{gridColumn:'1/-1'}}><label>Açıklama</label><textarea value={form.aciklama} onChange={e=>setForm({...form,aciklama:e.target.value})} rows={3} /></div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={()=>setModalAcik(false)}>İptal</button>
                <button type="submit" className="btn btn-primary">Görevi Ata</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
